import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import lookbookDataRaw from "../data/overtly.json"; // import JSON

// Add number as the first item in each slide
const lookbookData = lookbookDataRaw.map((slide) => {
  const num = slide.id.toString().padStart(2, "0"); // "01", "02", ...
  return {
    ...slide,
    items: [{ name: `${num}`, color: "" }, ...slide.items],
  };
});

const OvertlySection = () => {
  return (
    <div style={{ maxWidth: "600px", margin: "0 auto" }}>
      <Swiper
        navigation={true}
        modules={[Navigation, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        speed={2000}
        style={{ padding: "2rem 0" }}
      >
        {lookbookData.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img
                src={slide.img}
                alt={`Lookbook Slide ${slide.id}`}
                width={533}
                height={800}
                style={{ objectFit: "cover" }}
              />
              <ul style={{ listStyle: "none", padding: 0, marginTop: "1rem" }}>
                {slide.items.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: item.color === "" ? "1rem" : "0.3rem",
                    }}
                  >
                    <p>
                      {item.name}{" "}
                      {item.color && (
                        <span style={{ fontSize: "8px" }}>{item.color}</span>
                      )}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx>{`
        .swiper-button-next,
        .swiper-button-prev {
          color: white;
          width: 30px;
          height: 30px;
          top: 40%;
          transform: translateY(-50%);
        }
        .swiper-button-prev {
          left: 30px;
        }
        .swiper-button-next {
          right: 30px;
        }
        .swiper-button-next::after,
        .swiper-button-prev::after {
          font-size: 10px;
        }
      `}</style>
    </div>
  );
};

export default OvertlySection;
